// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { RestrictionsDialogMountPointProps } from './RestrictionsDialogMountPoint.tsx';
export { RestrictionsDialogTriggerWrapper } from './RestrictionsDialogTriggerWrapper.tsx';
export { RestrictionsDialogTrigger } from './RestrictionsDialogTrigger.tsx';
export { RestrictionsDialogMenuPropsProvider } from './RestrictionsDialogMenuPropsProvider.tsx';

export const LazyRestrictionsDialogMountPoint: LoadableType<RestrictionsDialogMountPointProps> =
	LoadableLazy<RestrictionsDialogMountPointProps>({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-RestrictionsDialogMountPoint" */ './RestrictionsDialogMountPoint.tsx'
				)
			).RestrictionsDialogMountPoint,
	});
